// src/App.js
import React from 'react';
import PortfolioWebsite from './components/PortfolioWebsite';

function App() {
  return (
    <PortfolioWebsite />
  );
}

export default App;